import { Component, ElementRef, ViewChild } from '@angular/core';
import { FiltrosNotaFiscal, NotaFiscalRelatorioItem } from './relatorio-nota-fiscal';

import { IdDescricao } from '@app/models/util/id-descricao';
import { ConsultasService } from '@app/services/consultas.service';
import debounce from '@app/utils/debounce';
import { UtilitarioService } from '@app/services/utilitario.service';
import { CurrencyPipe } from '@angular/common';
import { RelatorioService } from '@app/services/relatorio.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-relatorio-nota-fiscal',
  templateUrl: 'relatorio-nota-fiscal.component.html',
  styleUrls: ['relatorio-nota-fiscal.component.scss']
})
export class RelatorioNotaFiscalComponent {
  filtros: FiltrosNotaFiscal = new FiltrosNotaFiscal();
  listaParticipantes: IdDescricao[] = [];
  listaUsuarios: IdDescricao[] = [];
  dadosRelatorio: NotaFiscalRelatorioItem[] = [];
  valorFormatado: string = '';

  nomeParticipanteRelatorio: string = "";
  nomeEmissorNFS: string = "";

  // para método ngxtyped
  _debounceUsuario: () => void;
  _pesquisaUsuario: any;
  _debounceParticipante: () => void;
  _pesquisaParticipante: any;

  // pesquisar
  pesquisando: boolean = false;

  // impressao
  dataEmissaoRelatorio: Date;
  @ViewChild('relatorioNotaFiscal') relatorioNotaFiscal: ElementRef;

  constructor(
    private _relatorioService: RelatorioService,
    private _consultasService: ConsultasService,
    private _currencyPipe: CurrencyPipe,
    private _toastrService: ToastrService
  ) { }


  formataValorMonetario(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const stringNumerica = inputElement.value.replace(/\D/g, ''); // Remove non-digit characters
    const valorComCentavos = parseFloat(stringNumerica) / 100;

    this.filtros.ValorNota = valorComCentavos;
    this.valorFormatado = this._currencyPipe.transform(valorComCentavos, 'BRL', 'symbol', '1.2-2');
  }


  public pesquisar(): void {
    this.pesquisando = true;
    this.dataEmissaoRelatorio = new Date();

    this._relatorioService.obterRelatorioNotaFiscal(this.filtros).toPromise().then(
      dados => {
        this.dadosRelatorio = dados;
        this.pesquisando = false;
      },
      error => {
        this._toastrService.warning("Realize a pesquisa novamente");
        this.pesquisando = false;
      }
    );
  }

  public imprimir() {
    let conteudo = document.getElementById("relatorioNotaFiscal").innerHTML;
    UtilitarioService.imprimirHTML(conteudo, "Relatório de Notas Fiscais", this.montaImpressaoFiltros());
  }

  private montaImpressaoFiltros(){
    let objetoFiltros = new Map<string, string>();
    
    adicionaMapValido('Emitido em', this.dataEmissaoRelatorio.toLocaleString());

    if (this.filtros.QuantidadeRegistros != 0) {
      adicionaMapValido('Limite de Registros', this.filtros.QuantidadeRegistros);
    }
    if (this.filtros.ValorNota != 0) {
      adicionaMapValido('ValorNota', this.filtros.ValorNota);
    }
    if (this.filtros.Texto != '') {
      adicionaMapValido('Texto', this.filtros.Texto);
    }
    if (this.filtros.DataInicial != null) {
      parseDateAdicionaMap('Data Inicial', this.filtros.DataInicial.toLocaleString());
    }
    if (this.filtros.DataFinal != null) {
      parseDateAdicionaMap('Data Final', this.filtros.DataFinal.toLocaleString());
    }
    if (this.filtros.ParticipanteId != 0) {
      adicionaMapValido('Participante', this.nomeParticipanteRelatorio);
    }
    if (this.filtros.UsuarioEmissaoId != 0) {
      adicionaMapValido('Emitida por: ', this.nomeParticipanteRelatorio);;
    }

    function obtemDescricaoAdicionaMap(chave: string, listaItens: IdDescricao[], idItem: number){
      if(idItem){
        let valor = listaItens.find(x => x.Id === idItem).Descricao;
        objetoFiltros.set(chave, valor);
      } 
    }
    function parseDateAdicionaMap(textoChave: string, data: string){
      if(data && data.indexOf('-') >= 0){
        let dataPartes = data.split('-');
        let dataMontada = dataPartes[2] + '/' + dataPartes[1] + '/' + dataPartes[0];
        objetoFiltros.set(textoChave, dataMontada);
      }
    }
    function adicionaMapValido(chave: string, valor: any){
      if(valor){
        objetoFiltros.set(chave, valor.toString());
      }
    }
    let stringHtml = '';
    objetoFiltros.forEach((valor, chave) => {
      stringHtml += `<tr><td>${chave}</td><td>${valor}</td></tr>`;
    });
    return stringHtml;
  }
}
